module.exports = __webpack_public_path__ + "images/skewness-08-desktop.png";